import { render, staticRenderFns } from "./PageTabs.vue?vue&type=template&id=df6002a2"
import script from "./PageTabs.vue?vue&type=script&lang=ts"
export * from "./PageTabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports